const PurchaseSupplierSkusResumeHeader = [
  {
    group: "Pedido",
    columns: [
      {
        name: "",
        id: "pedido-id",
        show: false,
      },

      {
        name: "Numero",
        id: "pedido-numero",
        show: true,
      },
      {
        name: "Centro",
        id: "pedido-centro",
        show: true,
      },
      {
        name: "Sku",
        id: "pedido-sku",
        show: true,
      },
      {
        name: "Descricao",
        id: "pedido-descricao",
        show: true,
      },
    ],
  },
  {
    group: "Data",
    columns: [
      {
        name: "Prevista",
        id: "data-prevista",
        show: true,
      },
    ],
  },
  {
    group: "Quantidade",
    columns: [
      {
        name: "Total",
        id: "quantidade-total",
        show: true,
      },

      {
        name: "Pendente",
        id: "quantidade-pendente",
        show: true,
      },

      {
        name: "Agendar",
        id: "quantidade-agendar",
        show: true,
      },
    ],
  },
];

export default PurchaseSupplierSkusResumeHeader;
